/**
 * Search Form
 */

// Vendors
import $ from 'jquery';

$('[data-search-form-show]').on('click', (event) => {
  event.preventDefault();
  $('body').addClass('search-form-is-visible');
  setTimeout(() => {
    $('.search-form [name="s"]').focus();
  }, 300);
});

$('[data-search-form-hide]').on('click', (event) => {
  event.preventDefault();
  $('body').removeClass('search-form-is-visible');
  $('.search-form [name="s"]').val('');
});

$('[data-search-form-toggle]').on('click', (event) => {
  event.preventDefault();
  if ($('body').hasClass('search-form-is-visible')) {
    $('body').removeClass('search-form-is-visible');
    $('.search-form [name="s"]').val('');
  } else {
    $('body').addClass('search-form-is-visible');
    setTimeout(() => {
      $('.search-form [name="s"]').focus();
    }, 300);
  }
});
